import { LIMIT_HOTELS_VIEW, LIMIT_HOTELS_VIEW_RESORT } from '@/js/common/Constants/searchPageConstants';
import type { ExWindow } from '@ve/types';

declare let window: ExWindow;

export const RESORT_PAGE_TYPE = 'resort.ResortPage';
export const COUNTRY_PAGE_TYPE = 'country.CountryPage';

const LOAD_MORE_PAGE_TYPES = new Set<string>([RESORT_PAGE_TYPE, COUNTRY_PAGE_TYPE]);

export const AUTO_LOAD_PAGES_LIMIT = 2;

export const FIRST_MANUAL_PAGE_NUMBER = 1 + AUTO_LOAD_PAGES_LIMIT;

const SMALL_CHUNK_PAGES_COUNT = 3;

export function isLoadMorePageType(pageDataType?: string): boolean {
    return !!pageDataType && LOAD_MORE_PAGE_TYPES.has(pageDataType);
}

export function isLoadMoreEnabled(): boolean {
    return isLoadMorePageType(window.appConfig?.pageDataType);
}

export function getShownItemsCount(pageNumber: number, isLoadMorePage: boolean): number {
    if (pageNumber <= 0) {
        return 0;
    }

    if (!isLoadMorePage || pageNumber <= SMALL_CHUNK_PAGES_COUNT) {
        return LIMIT_HOTELS_VIEW * pageNumber;
    }

    return (LIMIT_HOTELS_VIEW * SMALL_CHUNK_PAGES_COUNT)
        + (LIMIT_HOTELS_VIEW_RESORT * (pageNumber - SMALL_CHUNK_PAGES_COUNT));
}

export function getChunkSize(pageNumber: number, isLoadMorePage: boolean): number {
    return getShownItemsCount(pageNumber, isLoadMorePage) - getShownItemsCount(pageNumber - 1, isLoadMorePage);
}

export function getPageRange(pageNumber: number, isLoadMorePage: boolean): { startIndex: number; endIndex: number } {
    return {
        startIndex: getShownItemsCount(pageNumber - 1, isLoadMorePage),
        endIndex: getShownItemsCount(pageNumber, isLoadMorePage),
    };
}

export function isAutoLoadAvailable(pageNumber: number, isLoadMorePage: boolean): boolean {
    return !isLoadMorePage || pageNumber < FIRST_MANUAL_PAGE_NUMBER;
}

export function isLoadMoreButtonAvailable(pageNumber: number): boolean {
    if (!isLoadMoreEnabled()) {
        return false;
    }

    if (window.appConfig?.pageDataType === RESORT_PAGE_TYPE) {
        return true;
    }

    return !isAutoLoadAvailable(pageNumber, true);
}
